import React, { useEffect, useRef } from 'react';
import { useVisualizacao } from './VisualizacaoContext';

import { MdKeyboardArrowDown } from 'react-icons/md';
import Tippy from '@tippyjs/react';

import ModalVisualizacao from './components/ModalVisualizacao';
import SelectVisualizacao from './components/SelectVisualizacao';
import { FaEye } from 'react-icons/fa';
import { useSearch } from '../Search/SearchContext';
import { useTableViewManager } from '~/context/tableViewManager';

import { Overlay, Popover } from 'react-bootstrap';

interface VisualizacaoContentProps {
  disabled?: boolean;
}

export const VisualizacaoContent: React.FC<VisualizacaoContentProps> = ({
  disabled = false,
}) => {
  const { isOpenPopup, setIsOpenPopup, isOpenModal } = useVisualizacao();
  const { View } = useSearch();
  const { viewCardSelected } = useTableViewManager();

  const target = useRef<HTMLButtonElement | null>(null);

  const labelRaw = viewCardSelected?.label?.toLowerCase();

  const labelView =
    !viewCardSelected || labelRaw === 'nenhuma' || labelRaw === ''
      ? View
      : labelRaw;

  const label =
    View?.toUpperCase() === 'PADRÃO' && !viewCardSelected?.value
      ? View
      : labelView;

  useEffect(() => {
    if (disabled) {
      setIsOpenPopup(false);
    }
  }, [disabled, setIsOpenPopup]);

  return (
    <>
      {isOpenModal && <ModalVisualizacao />}

      <button
        ref={target}
        type="button"
        title="CTRL + ALT + V"
        onClick={() => {
          if (disabled) return;
          setIsOpenPopup(!isOpenPopup);
        }}
        disabled={disabled}
        style={{
          backgroundColor: disabled ? '#d8d8d8' : '#57069e',
          color: disabled ? '#8a8a8a' : 'white',
          padding: '0.5rem 1rem',
          border: 'none',
          height: '2.5rem',
          borderTopLeftRadius: '0.25rem',
          borderBottomLeftRadius: '0.25rem',
          minWidth: '13.125rem',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        <Tippy
          placement="left"
          content="Visualização das colunas"
          arrow
          animation="scale"
        >
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              textAlign: 'center',
              width: '100%',
            }}
          >
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                width: '100%',
              }}
            >
              <FaEye size={18} />
              <span
                style={{
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  lineHeight: '1.3125rem',
                  whiteSpace: 'nowrap',
                }}
              >
                {label?.length > 10
                  ? `${label?.toLocaleUpperCase()?.slice(0, 10)}...`
                  : label?.toLocaleUpperCase()}
              </span>
            </div>
            <MdKeyboardArrowDown size={23} />
          </div>
        </Tippy>
      </button>

      <Overlay
        target={target.current}
        show={!disabled && isOpenPopup}
        placement="bottom-end"
        rootClose
        onHide={() => setIsOpenPopup(false)}
      >
        <Popover
          id="visualizacao-popover"
          style={{
            minWidth: '13.125rem',
            zIndex: 101,
          }}
        >
          <Popover.Content
            style={{
              maxHeight: '295px',
              overflowY: 'auto',
              padding: 0,
              marginTop: '-0.6rem',
            }}
          >
            <SelectVisualizacao />
          </Popover.Content>
        </Popover>
      </Overlay>
    </>
  );
};
